import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import '../static/css/SignIn.css';
import logo from '../static/images/images/a-logo-transperent.png';

const eyeIcon = (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
        <circle cx="12" cy="12" r="3" />
    </svg>
);

const eyeOffIcon = (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
        <line x1="1" y1="1" x2="23" y2="23" />
    </svg>
);

class SignIn extends Component {
    constructor() {
        super();
        this.state = {
            email: '',
            password: '',
            error: '',
            showPassword: false,
            submitting: false,
        };
        this.onChangeEmail = this.onChangeEmail.bind(this);
        this.onChangePassword = this.onChangePassword.bind(this);
        this.togglePasswordVisibility = this.togglePasswordVisibility.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
    }

    onChangeEmail(e) {
        this.setState({ email: e.target.value, error: '' });
    }

    onChangePassword(e) {
        this.setState({ password: e.target.value, error: '' });
    }

    togglePasswordVisibility() {
        this.setState((prev) => ({ showPassword: !prev.showPassword }));
    }

    isFormValid() {
        const validEmail = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.state.email);
        const validPassword = this.state.password.length > 0;
        return validEmail && validPassword;
    }

    async onSubmit(e) {
        e.preventDefault();
        if (!this.isFormValid() || this.state.submitting) return;
        this.setState({ submitting: true, error: '' });
        try {
            const response = await axios.post(
                process.env.REACT_APP_SERVER_API + '/auth/web-sign-in',
                { email: this.state.email, password: this.state.password }
            );
            const { token, user, upcoming_event } = response.data.data;
            localStorage.setItem('token', token);
            localStorage.setItem('user', JSON.stringify(user));
            localStorage.setItem('upcoming_event', JSON.stringify(upcoming_event));
            window.location.href = '/home';
        } catch (err) {
            const status = err.response && err.response.status;
            const data = err.response && err.response.data;
            let message = 'Something went wrong. Please try again.';
            if (status === 401) {
                message = typeof data === 'string' ? data : 'Invalid email or password.';
            } else if (status === 403) {
                message = typeof data === 'string' ? data : 'Your account cannot sign in at this time.';
            }
            this.setState({ submitting: false, error: message });
        }
    }

    render() {
        const { showPassword, submitting } = this.state;
        const valid = this.isFormValid();
        const buttonDisabled = !valid || submitting;
        return (
            <div className="signin-container">
                <div className="animates-logo-container">
                    <Link to="/"><img className="animates-logo hover" style={{width: "125px"}} src={logo} alt="" /></Link>
                    <div className="welcomecs-header-auth-links">
                        <Link to="/signup" className="welcomecs-header-auth-link">Sign Up</Link>
                    </div>
                </div>
                <h2 className="color-2 signin-title" style={{fontFamily: "'Chelsea Market', cursive"}}><u>Sign In</u></h2>
                {this.state.error && <p className="signin-error">{this.state.error}</p>}
                <form className="signin-form" onSubmit={this.onSubmit}>
                    <label className="signin-form-label" htmlFor="signin-email">Email</label>
                    <input
                        id="signin-email"
                        type="email"
                        className="signin-form-input"
                        value={this.state.email}
                        onChange={this.onChangeEmail}
                    />
                    <label className="signin-form-label" htmlFor="signin-password">Password</label>
                    <div className="signin-form-input-wrapper">
                        <input
                            id="signin-password"
                            type={showPassword ? "text" : "password"}
                            className="signin-form-input"
                            value={this.state.password}
                            onChange={this.onChangePassword}
                        />
                        <button
                            type="button"
                            className="signin-form-toggle-password"
                            onClick={this.togglePasswordVisibility}
                            aria-label={showPassword ? "Hide password" : "Show password"}
                        >
                            {showPassword ? eyeIcon : eyeOffIcon}
                        </button>
                    </div>
                    <button type="submit" className="signin-form-submit" disabled={buttonDisabled}>
                        {submitting ? 'Signing in…' : 'Sign In'}
                    </button>
                </form>
                <div className="signin-forgot-container">
                    <Link to="/forgot-password" className="welcomecs-header-auth-link">Forgot Password?</Link>
                </div>
                <div className="signin-signup-prompt">
                    <span>Don't have an account?</span>
                    <Link to="/signup" className="signin-signup-prompt-link" style={{textDecoration: 'none'}}>Sign Up</Link>
                </div>
                <p className="signin-footer">© 2026 AniMates. All rights reserved.</p>
            </div>
        );
    }
}

export default SignIn;
